
  import { create as createHubspotTicket } from '@/services/api/resources/bugReport';
  import { Button } from '@/ui/components/Button';
  import { InputField } from '@/ui/components/form';
  import { Modal } from '@/ui/components/Modal';
  import { CREATE_HUBSPOT_TICKET_MODAL_WIDTH } from '@/ui/components/modals/constants';
  import Spinner from '@/ui/components/Spinner.vue';
  import { toasted } from '@/ui/helpers';
  import { taskToPromise } from '@/ui/helpers/fpTsHelper';
  import { t } from '@/ui/i18n/i18n';
  import { defineComponent, ref } from 'vue';

  interface CreateHubspotModalProperties {
    active: boolean;
    title: string;
    contents: string;
    placeholder: string;
    subject: string;
    successMessage: string;
  }

  export default defineComponent<CreateHubspotModalProperties>({
    components: {
      InputField,
      Button,
      Spinner,
      Modal,
    },
    props: ['active', 'title', 'contents', 'placeholder', 'subject', 'successMessage'],
    setup(props, { emit }) {
      const loading = ref(false);
      const text = ref('');

      const close = () => {
        loading.value = false;
        text.value = '';
        emit('close');
      };

      const submit = () => {
        loading.value = true;

        taskToPromise(() => createHubspotTicket(props.subject, text.value)).then(() => {
          toasted.success(props.successMessage);
          close();
        }).catch(error => {
          console.error('Failed to save hubspot ticket', { text: text.value, error });
          toasted.error(t('dictionary.api-error.unknown'));
        });
      };

      const updateText = (newText: string) => {
        text.value = newText;
      };

      return {
        close,
        submit,
        loading,
        CREATE_HUBSPOT_TICKET_MODAL_WIDTH,
        text,
        updateText,
      };
    },
  });
